import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import * as $ from "jquery";
import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-fk-storybook',
  templateUrl: './fk-storybook.component.html',
  styleUrls: ['./fk-storybook.component.css']
})
export class StorybookComponent implements OnInit {

  public play_btn_show:boolean = true;
  public highlight_btn_show: boolean = true;
  public bloburl: string;
  public  my_current_link:string;
 
  playaudio()
  {
  var $f=$("#idIframe");
  $f[0].contentWindow.pageplayaudio();
  }
  pauseaudio()
  {
  var $f=$("#idIframe");
  $f[0].contentWindow.pagepauseaudio();
  }

  disablehighlight()
  {
  var $f=$("#idIframe");
  $f[0].contentWindow.off_highlight();
  }
  enablehighlight()
  {
  var $f=$("#idIframe");
  $f[0].contentWindow.on_highlight();
  }


  pageturnleft()
  {
  var $f=$("#idIframe");
    var page_count=$f[0].contentWindow.current_page_number();
    if(page_count>0)
    {
  $f[0].contentWindow.pageturnleft();
  }
  }

  pageturnright()
  {
  var $f=$("#idIframe");
    $f[0].contentWindow.pageturnright();

  }

  gotohome()
  {
  var $f=$("#idIframe");
  $f[0].contentWindow.gotohomepage();
  }

  

    private loadScript(scriptUrl: string) {

        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script');
            scriptElement.src = scriptUrl;
            scriptElement.onload = resolve;
            document.body.appendChild(scriptElement);
        })
    }
    refresh(): void {
        location.reload(true);
    }
  constructor(
        private sessionService: SessionService,
        private route: ActivatedRoute,
        private router: Router
      ) {

    this.bloburl = this.sessionService.bloburl;
      }

  ngOnInit()
  {

    var img_url = this.bloburl;
    let id = this.route.snapshot.paramMap.get('id');
    var my_id = +id;
    var iframe_story_url = "../../../assets/fk-storybook/storybook" + id + "/storybook" + id + ".html";
    

    if ((id == "1" || id == "2" || id == "3" || id == "4" || id == "6" || id == "8" || id == "9" || id == "11")) {
      $('#idIframe', window.parent.document).addClass("ipad_singlepage");
    }
    else if ((id == "5" || id == "7" || id == "10" || id == "12")) {
      $('#idIframe', window.parent.document).addClass("ipad_doublepage");
    }

    else { }

    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
    if (isIOS) {

      $('.ipad_singlepage', window.parent.document).addClass("ipad_single");
      $('.ipad_doublepage', window.parent.document).addClass("ipad_double");

    }
    else if (android_dev) {

      if (samsung_browser) {
        $('.ipad_singlepage', window.parent.document).addClass("android_samsung_single");
        $('.ipad_doublepage', window.parent.document).addClass("android_samsung_double");
      }
      else if (chrome_browser) {
        $('.ipad_singlepage', window.parent.document).addClass("android_chrome_single");
        $('.ipad_doublepage', window.parent.document).addClass("android_chrome_double");

      }
    }

    $("#idIframe").attr("src", iframe_story_url);

    //for image/audio auto URL
    $("#idIframe").attr("myimageurl", img_url);
    //dynamic global routing
    var links = [
      "/rbpagech01/fk-rb-pgs-ch01-page7",
      "/rbpagech02/fk-rb-pgs-ch02-page15",
      "/rbpagech03/fk-rb-pgs-ch03-page27",
      "/rbpagech04/fk-rb-pgs-ch04-page39",
      "/rbpagech05/fk-rb-pgs-ch05-page53",
      "/rbpagech06/fk-rb-pgs-ch06-page65",
      "/rbpagech07/fk-rb-pgs-ch07-page77",
      "/rbpagech08/fk-rb-pgs-ch08-page85",
      "/rbpagech09/fk-rb-pgs-ch09-page101",
      "/rbpagech10/fk-rb-pgs-ch10-page115",
      "/rbpagech11/fk-rb-pgs-ch11-page131",
      "/rbpagech12/fk-rb-pgs-ch12-page143"

    ];
    var message =links[my_id - 1];
    this.my_current_link = message;
   }
}
